import { render, staticRenderFns } from "./create-page.vue?vue&type=template&id=df068ee2&scoped=true"
import script from "./create-page.vue?vue&type=script&lang=js"
export * from "./create-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df068ee2",
  null
  
)

export default component.exports